import { render, staticRenderFns } from "./MainProfileIcon.vue?vue&type=template&id=3b97ecbd&scoped=true&"
import script from "./MainProfileIcon.vue?vue&type=script&lang=js&"
export * from "./MainProfileIcon.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "3b97ecbd",
  null
  ,true
)

export default component.exports